export default __webpack_public_path__ + "static/media/add-pdf.2a8350e8.svg";